import { render, staticRenderFns } from "./OsChangePasswordForm.vue?vue&type=template&id=b0e9bb5c&scoped=true"
import script from "./OsChangePasswordForm.vue?vue&type=script&lang=ts"
export * from "./OsChangePasswordForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e9bb5c",
  null
  
)

export default component.exports